import { alpha } from '@mui/material';

export const SURFACE_DARK = '#232329';

export const CONFIG_DARK = {
  surface: SURFACE_DARK,
  elevated: '#2a2a31',
  sunken: '#1c1c22',
  border: alpha('#ffffff', 0.08),
  borderStrong: alpha('#ffffff', 0.12),
  divider: alpha('#ffffff', 0.06),
  textMuted: '#9ca3af',
  text: '#f5f5f5',
};

export function darkLinear(stops) {
  return `linear-gradient(145deg, ${stops})`;
}

/** Shared dark card chrome (messaging panel, hotel config cards, etc.) */
export const darkSurfaceCardSx = {
  background: darkLinear(
    `${CONFIG_DARK.elevated} 0%, ${CONFIG_DARK.surface} 48%, ${CONFIG_DARK.sunken} 100%`
  ),
  border: `1px solid ${CONFIG_DARK.borderStrong}`,
  boxShadow: `
    0 1px 0 ${alpha('#ffffff', 0.06)} inset,
    0 8px 24px ${alpha('#000000', 0.35)}
  `,
};
